import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderDeleteConfirmationDialog = (data) => openPopupHelper({ popupName: popupNames.DELETE_CONFIRMATION_DIALOG, data });
